(function () {
  window.OAInputFieldValidator = function (options) {
    var id = options.id;
    var showError = options.showError;
    var hideError = options.hideError;
    var callback = options.callback;
    var events = options.events;
    var eventNamespace = options.eventNamespace || 'default';
    
    var input = $('input#' + id);

    if (typeof events === 'undefined') {
      events = 'change input keyup paste';
    }
    
    events = events.split(/ /).map(function (event) {
      return event + '.oavalidator.' + eventNamespace;
    }).join(' ');

    input.off(events).on(events, function (e) {
      callback(e.target.value, input, showError, hideError);
    });

    callback(input.val(), input, showError, hideError);

    return input;
  };

  window.OAAccountAddressInputFieldValidator = function (options) {
    var input;
    if (typeof options.input !== 'undefined') {
      input = $(options.input); 
    }
    var id = options.id || input.attr('id');
    var callback = options.callback;
    var events = options.events;
    var eventNamespace = options.eventNamespace || 'default';
    if (!input || input.length < 1) {
      input = $('input#' + id);
    }
    var group = input.closest('.form-group');
    var messageId = id.replace('address_', '') + '-' + eventNamespace;
    var message = group.find('#error-for-' + messageId);
    if (message.length < 1) {
      message = $('<p></p>')
      .addClass('account-input-error hidden')
      .attr('id', 'error-for-' + messageId);
      group.append(message);
    }

    function showError(error) {
      message.html(error).removeClass('hidden');
    }

    function hideError() {
      message.text('').addClass('hidden');
    }

    return window.OAInputFieldValidator({
      id: id,
      showError: showError,
      hideError: hideError,
      callback: callback,
      events: events,
      eventNamespace: eventNamespace
    });
  };

  window.OACheckoutInputFieldValidator = function (options) {
    var id = options.id;
    var callback = options.callback;
    var events = options.events;
    var eventNamespace = options.eventNamespace || 'default';
    
    var input = $('input#' + id);
    var field = input.closest('.field');
    var messageId = id.replace('checkout_shipping_address_', '') + '-' + eventNamespace;
    var message = field.find('#error-for-' + messageId);
    if (message.length < 1) {
      message = $('<p></p>')
      .addClass('field__message field__message--error')
      .attr('id', 'error-for-' + messageId);
      field.append(message);
    }

    function toggleData(hasError) {
      var value = (field.attr('data-validation-custom-error') || '');
      if (hasError) {
        if (value.indexOf(messageId) === -1) {
          value += ' ' + messageId;
        }
      } else {
        value = value.replace(messageId, '');
      }
      value = value.trim();
      field.attr('data-validation-custom-error', value);
      return value.length > 0;
    }
    
    function showError(error) {
      message.html(error);
      if (toggleData(true)) {
        field.addClass('field--custom-error');
      }
    }

    function hideError() {
      message.text('');
      if (!toggleData(false)) {
        field.removeClass('field--custom-error');
      }
    }

    return OAInputFieldValidator({
      id: id,
      showError: showError,
      hideError: hideError,
      callback: callback,
      events: events,
      eventNamespace: eventNamespace
    });
  };
})();

(function () {
  window.OAMaxLengthValidation = function (options) {
    var maxLength = options.maxLength;
    var initCallback = options.initCallback;
    var currentLang = options.currentLang;

    var maxLengthErrorMessage;

    switch (currentLang) {
      case 'de':
        maxLengthErrorMessage = "Maximal [x] Zeichen erlaubt";
        break;
      case 'fr':
        maxLengthErrorMessage = "Limité à un maximum de [x] caractères";
        break;
      case 'en':
      default:
        maxLengthErrorMessage = "Maximum of [x] characters allowed";
        break;
    }

    function getMaxLength(input) {
      if (typeof maxLength === 'function') {
        return Math.max(0, maxLength(input));
      }
      
      return maxLength;
    }

    function onInput(val, input, showError, hideError) {
      if (typeof val !== 'undefined' && val.length > 0) {
        var max = getMaxLength(input);
        if (val.length >= max) {
          input.val(val.substr(0, max));
          showError(maxLengthErrorMessage.replace('[x]', max));
        } else {
          hideError();
        }
      }
    }

    var inProgress = false;

    function init() {
      // Do nothing when already in progress
      if (inProgress) { return; }
      inProgress = true;
      if (typeof initCallback === 'function') {
        initCallback(onInput);
      }
      inProgress = false;
    }

    init();

    return {
      init: init,
      onInput: onInput
    }
  };
})();

(function () {
  window.OAPoBoxValidation = function (options) {
    var initCallback = options.initCallback;
    var currentLang = options.currentLang;

    var poBoxRegex = /\b(?:p(?:ost(?:al)?)?[\.\-\s]*(?:(?:o(?:ffice)?[\.\-\s]*)?B(?:ox|in|\b|\d)|o(?:ffice|\b)(?:[-\s]*\d)|code)|box[-\s\b]*\d)/i;
    var poBoxErrorMessage;

    switch (currentLang) {
      case 'de':
        poBoxErrorMessage = "PO Box kann nicht beliefert werden";
        break;
      case 'fr':
        poBoxErrorMessage = "La boîte postale ne peut pas être livrée";
        break;
      case 'en':
      default:
        poBoxErrorMessage = "Unable to deliver to PO Box";
        break;
    }

    function onInput(val, input, showError, hideError) {
      if (typeof val !== 'undefined' && val.length > 0) {
        if (poBoxRegex.test(val)) {
          showError(poBoxErrorMessage);
        } else {
          hideError();
        }
      }
    }

    var inProgress = false;

    function init() {
      // Do nothing when already in progress
      if (inProgress) { return; }
      inProgress = true;
      if (typeof initCallback === 'function') {
        initCallback(onInput);
      }
      inProgress = false;
    }

    init();

    return {
      init: init,
      onInput: onInput
    }
  };
})();

(function () {
  window.OAAsciiCharactersValidation = function (options) {
    var initCallback = options.initCallback;
    var currentLang = options.currentLang;

    var foreignRegex = /[^\u0000-\u00ff]/;
    var foreignErrorMessage;

    switch (currentLang) {
      case 'de':
        foreignErrorMessage = "Lieferungen an Adressen, die nicht aus lateinischen Buchstaben bestehen, sind leider nicht möglich";
        break;
      case 'fr':
        foreignErrorMessage = "Les livraisons aux adresses qui ne sont pas donnés en lettres latines ne sont pas possibles";
        break;
      case 'en':
      default:
        foreignErrorMessage = "Delivery is not possible to addresses that have not been provided in latin letters";
        break;
    }

    function onInput(val, input, showError, hideError) {
      if (typeof val !== 'undefined' && val.length > 0) {
        if (foreignRegex.test(val)) {
          showError(foreignErrorMessage);
        } else {
          hideError();
        }
      }
    }
    
    var inProgress = false;

    function init() {
      // Do nothing when already in progress
      if (inProgress) { return; }
      inProgress = true;
      if (typeof initCallback === 'function') {
        initCallback(onInput);
      }
      inProgress = false;
    }

    init();
    
    return {
      init: init,
      onInput: onInput
    }
  };
})();

(function () {
  window.OAEmailValidation = function (options) {
    var initCallback = options.initCallback;
    var currentLang = options.currentLang;
    var id = options.id;
    var showError = options.showError;
    var hideError = options.hideError;
    var events = options.events || 'blur';

    var invalidEmailMessage;
    var suggestionEmailMessage;
    var validationCache = {};

    switch (currentLang) {
      case 'de':
        invalidEmailMessage = "Kann es sein, dass deine Email Adresse nicht richtig ist?";
        suggestionEmailMessage = "Meinst du vielleicht: [x]";
        break;
      case 'fr':
        invalidEmailMessage = "Est-il possible que ton adresse e-mail ne soit pas vraiment correcte?";
        suggestionEmailMessage = "C'est peut-être plutôt: [x]";
        break;
      case 'en':
      default:
        invalidEmailMessage = "Can it be that your email address is not correct?";
        suggestionEmailMessage = "Do you mean: [x]";
        break;
    }

    function validateEmail(email) {
      if (typeof validationCache[email] !== 'undefined') {
        return Promise.resolve(validationCache[email]);
      }

      return axios.get('https://api.emailverifyapi.com/api/a/v1', {
        timeout: 5000,
        params: {email: email, correct: 1},
      }).then(function (response) {
        var data = response.data;

        var isValid = true;
        var suggestion;

        if (typeof data !== 'undefined' && typeof data.status !== 'undefined') {
          isValid = data.status.toLowerCase() === 'ok';
          if (data.emailAddressSuggestion.length > 0) {
            suggestion = data.emailAddressSuggestion;
          }
        }

        var res = {
          isValid: isValid,
          suggestion: suggestion,
        };

        validationCache[email] = res;

        return res;
      });
    }

    function onInput(val, input, showError, hideError) {
      if (typeof val !== 'undefined' && val.length > 0) {
        validateEmail(val).then(function (data) {
          if (!data.isValid) {
            if (typeof data.suggestion !== 'undefined') {
              showError(invalidEmailMessage + '<br>' + suggestionEmailMessage.replace('[x]', data.suggestion));
            } else {
              showError(invalidEmailMessage);
            }
          } else {
            hideError();
          }
        }).catch(function () {
          hideError();
        });
      } else {
        hideError();
      }
    }

    var inProgress = false;

    function init() {
      // DISABLED
      return;
      
      // Do nothing when already in progress
      if (inProgress) { return; }
      inProgress = true;

      if (typeof initCallback === 'function') {
        initCallback(onInput);
      } else if (typeof id !== 'undefined' && typeof showError !== 'undefined' && typeof hideError !== 'undefined') {
        window.OAInputFieldValidator({
          id: id,
          showError: showError,
          hideError: hideError,
          callback: onInput,
          events: events
        });
      }

      inProgress = false;
    }

    init();

    return {
      init: init,
      validateEmail: validateEmail,
      onInput: onInput
    };
  };
})();

(function () {
  window.OAPhoneValidation = function (options) {
    var initCallback = options.initCallback;
    var currentLang = options.currentLang;
    var currentShop = options.currentShop.toUpperCase();
    var hiddenInput = options.hiddenInput || '';
    var id = options.id;
    var showError = options.showError;
    var hideError = options.hideError;

    var iti;    
    var errorMap;

    switch (currentLang) {
      case 'de':  
        errorMap = ["Ungültige Nummer", "Ungültige Vorwahl", "Zu kurz", "Zu lang", "Ungültige Nummer"];
        break;
      case 'fr':
        errorMap = ["Numéro invalide", "Code pays non valide", "Trop court", "Trop long", "Numéro invalide"];
        break;
      case 'en':
      default:
        errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
        break;
    }

    var shops = {
      US: {
        countries: ['US']
      },
      CA: {
        countries: ['CA']
      },
      AU: {
        countries: ['AU', 'NZ']
      },
      UK: {
        countries: ['GB', 'GG', 'IM', 'JE']
      },
      DE: {
        countries: ['AT', 'CH', 'DE', 'LI']
      },
      EU: {
        countries: ['AX', 'BE', 'BG', 'BO', 'CY', 'CZ', 'DK', 'EE', 'ES', 'FI', 'FR', 'GI', 'GR', 'HR', 'HU', 'IE', 'IS', 'IT', 'LT', 'LU', 'LV', 'MC', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'RS', 'RU', 'SE', 'SI', 'SK', 'TR', 'UA', 'XK']
      },
      COM: {
        countries: ['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AW', 'AZ', 'BA', 'BB', 'BD', 'BF', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CC', 'CD', 'CF', 'CG', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'DJ', 'DM', 'DO', 'DZ', 'EC', 'EG', 'EH', 'ER', 'ET', 'FJ', 'FK', 'FM', 'FO', 'GA', 'GD', 'GE', 'GF', 'GH', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HT', 'ID', 'IL', 'IN', 'IO', 'IQ', 'IR', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LK', 'LR', 'LS', 'LY', 'MA', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NP', 'NR', 'NU', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PM', 'PN', 'PR', 'PS', 'PW', 'PY', 'QA', 'RE', 'RW', 'SA', 'SB', 'SC', 'SD', 'SG', 'SH', 'SJ', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TT', 'TV', 'TW', 'TZ', 'UG', 'UM', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW']
      }
    };

    function getPreferredCountries() {
      if (typeof currentShop === 'undefined' || currentShop.length === 0) { return []; }
      var shop = shops[currentShop];
      if (typeof shop === 'undefined') { return []; }
      return shop.countries.length > 15 ? [] : shop.countries.map(function (country) { return country.toLowerCase(); });
    }

    function isPhoneValid() {
      var isValid = typeof iti !== 'undefined' && iti.isValidNumber();
      if (typeof window.intlTelInput.utils !== 'undefined') {
        var e164Number = iti.getNumber(window.intlTelInput.utils.numberFormat.E164);
        if (typeof e164Number === 'string') {
          isValid = isValid && e164Number.replace(/\s+/g, '').length <= 15;
        }
      }
      return isValid;
    }

    function onInput(val, input, showError, hideError) {
      if (typeof val !== 'undefined' && val.length > 0) {
        val = val.replace(/[^0-9\s+\-()]+/gi, '');
        val = val.substr(0, 1) + val.substr(1).replace(/\+/gi, '');
        input.val(val);
        if (typeof iti !== 'undefined' && typeof window.intlTelInput.utils !== 'undefined') {
          var e164Number = iti.getNumber(window.intlTelInput.utils.numberFormat.E164);
          if (typeof e164Number === 'string') {
            iti.setNumber(e164Number);
          }
        }

        if (!isPhoneValid() && val !== '+'+iti.getSelectedCountryData().dialCode) {
          showError(errorMap[Math.max(0, iti.getValidationError())]);
        } else {
          hideError();
        }
      } else {
        hideError();
      }
    }
    
  function showOnlyEnglishCountryNames() {
  if (window.intlTelInput && typeof window.intlTelInput.getCountryData === 'function') {
    var countryData = window.intlTelInput.getCountryData();
    for (var i = 0; i < countryData.length; i++) {
      countryData[i].name = countryData[i].name.replace(/(.+)\((.+)\)/, "$1");
    }
  } else {
    console.warn("intlTelInput is not available.");
  }
}

function showOnlyLocalizedCountryNames() {
  if (window.intlTelInput && typeof window.intlTelInput.getCountryData === 'function') {
    var countryData = window.intlTelInput.getCountryData();
    for (var i = 0; i < countryData.length; i++) {
      countryData[i].name = countryData[i].name.replace(/(.+)\((.+)\)/, "$2");
    }
  } else {
    console.warn("intlTelInput is not available.");
  }
}

    var inProgress = false;

    function init() {
      // Do nothing when already in progress
      if (inProgress) { return; }
      inProgress = true;
      
      showOnlyEnglishCountryNames();
      
      var input = document.getElementById(id);
      
      iti = window.intlTelInput(input, {
        nationalMode: false,
        preferredCountries: getPreferredCountries(),
        initialCountry: 'auto',
        formatOnDisplay: true,
        autoHideDialCode: false,
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/23.0.4/js/utils.min.js',
        geoIpLookup: function (success, failure) {	
          GeoRedirect.fetchData(function (data) {	
            success(data.country_code.toLowerCase());	
          }, function () {	
            success(getPreferredCountries()[0] || 'us');	
          });	
        },
      });

      window.iti =iti;

      iti.promise.then(function () {
        if (typeof initCallback === 'function') {
          initCallback(onInput);
        } else if (typeof id !== 'undefined' && typeof showError !== 'undefined' && typeof hideError !== 'undefined') {
          window.OAInputFieldValidator({
            id: id,
            callback: onInput,
            showError: showError,
            hideError: hideError,
            eventNamespace: 'phone'
          });
        }

        inProgress = false;
      });
    }

    init();

    return {
      init: init,
      isValid: isPhoneValid,
      onInput: onInput,
      iti: iti
    };
  };

})();

(function () {

  window.OACheckoutZipValidation = function (options) {
    var countryCodes = options.countryCodes || [];
    var initCallback = options.initCallback;
    var currentLang = options.currentLang;

    var input,
        field,
        countryInput,
        currentState,
        initialState = {
          placeholder: undefined,
          label: undefined,
          ariaRequired: undefined,
          fieldClass: undefined
        },
        callbacks = {
          showError: undefined,
          hideError: undefined
        };

    var errorMessage;

    switch (currentLang) {
      case 'de':
        errorMessage = "Gib eine Postleitzahl ein";
        break;
      case 'fr':
        errorMessage = "Entre un code postal";
        break;
      case 'en':
      default:
        errorMessage = "Enter a postal code";
        break;
    }

    function onInput(val, input, showError, hideError) {
      if (typeof initialState.ariaRequired === 'undefined') {
        callbacks.showError = showError;
        callbacks.hideError = hideError;
        return;
      }
      if (input.attr('aria-required') === 'true' && !field.classList.contains('hidden') && (typeof val === 'undefined' || val.length < 1)) {
        showError(errorMessage);
      } else {
        hideError();
      }
    }

    function isZipInvalid() {
      return input && input.getAttribute('aria-required') === 'true' && !field.classList.contains('hidden') && input.value.trim().length < 1;
    }

    function isZipRequiredForCountry(countryCode) {
      if (!countryCode) { return null; }
      return countryCodes.indexOf(countryCode) !== -1; 
    }

    function toggleRequired(required) {
      if (typeof required !== 'boolean') {
        if (typeof initialState.ariaRequired === 'undefined') { return; }
        required = undefined;
      }
      currentState = required;
      if (!input) { return; }
      if (required) {
        input.setAttribute('aria-required', true);
        if (input.placeholder.indexOf('*') === -1) {
          input.placeholder += '*';
        }
        input.labels.forEach(function (label) {
          if (label.textContent.indexOf('*') === -1) {
            label.textContent += '*';
          }
        });
        if (field) {
          field.classList.remove('field--optional');
          field.classList.add('field--required');
        }
        $(field).closest('form').off('submit.oavalidator.zip').on('submit.oavalidator.zip', function (event) {
          if (currentState && isZipInvalid()) {
            event.preventDefault();
            event.stopPropagation();
            $(input).trigger('input');
          }
        });
      } else {
        input.setAttribute('aria-required', initialState.ariaRequired);
        input.placeholder = initialState.placeholder;
        input.labels.forEach(function (label) {
          label.textContent = initialState.label;
        });
        if (field) {
          field.classList.remove('field--required');
          field.classList.add(initialState.fieldClass);
        }
        $(field).closest('form').off('submit.oavalidator.zip');
      }
      if (callbacks.hideError) {
        callbacks.hideError();
      }
    }

    function getCountryCode() {
      if (!countryInput) { return null; }
      var option = countryInput.options[countryInput.selectedIndex];
      if (!option) { return null; }
      return option.dataset.code;
    }

    function setupCountryCodeListener() {
      if (!countryInput) { return; }
      countryInput.addEventListener('input', function (event) {
        var option = event.target.options[event.target.selectedIndex];
        if (!option || !option.dataset.code) { return; }
        setTimeout(function () {
          toggleRequired(isZipRequiredForCountry(option.dataset.code.toUpperCase()));              
        }, 100);
      }); 
    }

    function hasCountry() {
      if (!countryInput) { return; }
      var shippingCountryCodes = Array.prototype.slice.call(countryInput.options).map(function (option) {
        return option.getAttribute('data-code');
      }).filter(function (code) { 
        return Boolean(code); 
      });
      return shippingCountryCodes.filter(function (code) {
        return countryCodes.indexOf(code) !== -1;
      }).length > 0;
    }

    function initInitialState() {
      if (typeof initialState.ariaRequired !== 'undefined') { return; }
      if (!input) { return; }

      initialState.placeholder = input.placeholder;
      initialState.label = input.labels.length > 0 ? input.labels[0].textContent : undefined;
      initialState.ariaRequired = input.getAttribute('aria-required') === 'true';
      initialState.fieldClass = field.classList.contains('field--required') ? 'field--required' : 'field--optional'
    }

    function setupFormSubmitValidator() {
      $(field).closest('form').off('submit.oavalidator.zip').on('submit.oavalidator.zip', function (event) {
        if (isZipRequiredForCountry(getCountryCode())) {
          if (isZipInvalid()) {
            event.preventDefault();
            event.stopPropagation();
          }
          toggleRequired(true);
        } else {
          toggleRequired(false);
        }
      }); 
    }

    var inProgress = false;

    function init() {
      // Do nothing when already in progress
      if (inProgress) { return; }
      inProgress = true;
      countryInput = document.getElementById('checkout_shipping_address_country') 
      if (hasCountry()) { 
        if (!input) {
          input = document.getElementById('checkout_shipping_address_zip');
          field = input.closest('.field');
        }
        if (typeof initCallback === 'function') {
          input = initCallback(onInput).get(0);
          field = input.closest('.field');
        } else {
          OACheckoutInputFieldValidator({
            id: 'checkout_shipping_address_zip',
            callback: onInput,
            eventNamespace: 'zip',
          });
        }
        initInitialState();
        setTimeout(function () {
          toggleRequired(isZipRequiredForCountry(getCountryCode()));        
        }, 100);
        setupCountryCodeListener();
      }
      inProgress = false;
    }

    var addressSelect = document.getElementById('checkout_shipping_address_id');
    if (addressSelect) {
      addressSelect.addEventListener('input', function () {
        setTimeout(init, 10);
      }, { passive: true });
    }

    init();

    return {
      init: init,
      isZipInvalid: isZipInvalid,
      isZipRequiredForCountry: isZipRequiredForCountry,
      toggleRequired: toggleRequired,
      onInput: onInput
    }
  };

})();